

import Vue, {PropType} from "vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {UNSAVED_OBJECT_ID} from "../../model/ProductBusinessLogic";
import {CategoryNode, ContentNode, NavigationController} from "../../model/product/NavigationController";
import {Product} from "../../model/rest/data-contracts";

export default Vue.extend({
  name: "ContentBreadcrumb",
  props: {
    matchedNode: {
      type: Object as PropType<CategoryNode>,
      default: () => ProductModelFactory.createEmptyCategoryNode(),
    },
    product: {
      type: Object as PropType<Product>,
      default: () => ProductModelFactory.createEmptyOverviewProduct(),
    },
  },
  computed: {
    contentTree(): CategoryNode {
      return this.$store.getters["navigation/contentTree"];
    },
    bItems(): Array<any> {
      if (this.matchedNode.id === UNSAVED_OBJECT_ID && this.product.id === UNSAVED_OBJECT_ID) {
        return [];
      }

      const parentList = this.matchedNode.id !== UNSAVED_OBJECT_ID
        ? NavigationController.getParentList(this.matchedNode)
        : NavigationController.getParentList(this.$store.getters["navigation/getCategoryBdId"](
            this.$store.getters["navigation/getCategoryProductsByProductId"](this.product.id)[0].categoryId,
          ),
        );
      const _this = this;
      const items = parentList
        .map((node: ContentNode) => ({
          text: _this.$t(node.name!),
          to: NavigationController.toURL(node),
        }));
      if (this.product!.id !== UNSAVED_OBJECT_ID) {
        items.push({
          text: this.product.name,
          to: "",
        });
      }
      return items;
    },
  },
});
